import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import CardGroup from '../common/CardGroup';
import Loader from '../Loader';
import { API } from 'aws-amplify';
import { useAppContext } from '../../libs/contextLib';
import Moment from 'react-moment';
import 'moment/locale/es';
import './OrdersList.css';
import OrderStatusBadge from '../common/OrderStatusBadge';

function renderOrderStatus(o) {
  return <OrderStatusBadge status={o.status} />;
}

export default function OrdersList({ user: userProp }) {
  const { session } = useAppContext();
  const user = userProp;
  const [orders, setOrders] = useState(null);
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    async function fetchOrders() {
      setLoading(true);
      try {
        if (!user || !user._id || !user.email) return setOrders([]);
        const orders = await API.get("vivelo", `/cart/orders?user=${user._id}|${user.email}`);
        setOrders(orders?.items || []);
      } catch (e) {
        setOrders([]);
      } finally {
        setLoading(false);
      }
    }
    fetchOrders();
  }, [user]);

  if (loading) return <Loader />;
  if (!orders || orders.length === 0) return <div className="orders-list-empty">Aún no has realizado ninguna compra.</div>;

  return (
    <div className="orders-list">
      <h1 className="orders-list-title">Mis Órdenes</h1>
      {orders.map(o => {
        const itemSummary = o.tickets.map(t => (
          <div className="orders-list-item-summary" key={t._id}>
            <span className="orders-list-item-show">{t.show_name}</span>
            {t.description && <span className="orders-list-item-desc">{t.description}</span>}
            <span className="orders-list-item-qty">× {t.quantity}</span>
          </div>
        ));
        return (
          <CardGroup className="orders-list-card" key={o._id}>
            <div className="orders-list-card-mainrow">
              <div className="orders-list-card-maincol1">
                <div className="orders-list-order-id-title">Orden #{o.order_number || o._id}</div>
                <div className="orders-list-order-date"><Moment format="D MMM YYYY, HH:mm" locale="es">{o.createdAt}</Moment></div>
                
              </div>
              <div className="orders-list-card-maincol2">
                {renderOrderStatus(o)}
                <div className="orders-list-card-total">Q{o.total.toFixed(2)}</div>
                <div className="orders-list-card-tickets">{o.tickets.reduce((total, t) => total + t.quantity, 0)} boleto(s)</div>
              </div>              
            </div>
            <div className="">
              <div className="orders-list-items-summary">{itemSummary}</div>
            </div>
            <div className="orders-list-card-footer">
              <div className="orders-list-card-actions">
                <button className="btn-theme-primary btn-order-details" onClick={() => history.push(`/orders/${o._id}`)}>Ver detalles</button>
              </div>
            </div>
          </CardGroup>
        );
      })}
    </div>
  );
} 